<div class=" mt-4">
  <section>
      <div class="scrollmenu">
          <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
          <a [routerLink]="['/pos/customer/new']"> Customer </a>
          <a [routerLink]="['/pos/Employee/new']"> Employee </a>
          <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/orders/new']"> Orders</a>
          <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
          <a [routerLink]="['/pos/category/new']"> Item-Category </a>
          <a [routerLink]="['/pos/item/new']"> Items </a>
          <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
          <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
          <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
          <a [routerLink]="['/pos/payment/new']"> Payment </a>
          <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
          <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
      </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-12">
                  <div class="text-right py-2">
                    <button class="dash-btns mr-3" type="button" id="CustomerDetails" (click)="CustomerDetailshide()"> Customer Details</button>
                    <button class="dash-btns" type="button" id="ShippingAddress"
                      (click)="showhideisShipping()">Shipping Address</button>
        
                  </div>
              </div>
              <div class="col-md-12">
                <div class="d-inline">
                  <h4 class="font-weight-bold d-inline">Create Order here.</h4>
                  <h6 class="pt-2 pr-2 d-inline float-right" style="font-size: 16px;" *ngIf="discAmount"> Bill &nbsp; <strong> {{currency}} {{TBill| number : '1.2-2'}} </strong></h6>
                  <h6 class="pt-2 pr-2 d-inline float-right" style="font-size: 16px;" *ngIf="discAmount">DisCount Amount &nbsp; <strong> {{currency}} {{DAmount| number : '1.2-2'}} </strong></h6>
                  <h6 class="pt-2 pr-2 d-inline float-right" style="font-size: 16px;" *ngIf="isbillcalculate">Total Bill &nbsp; <strong> {{currency}} {{Bill| number : '1.2-2'}} </strong></h6>
                </div>
              </div>
              <div class="col-md-12 "> 
                  <form #fnewprepaidcard="ngForm">
      
                    <div class="col-md-12 px-0" *ngIf="isNewOrder">
                      <div class="row m-0 mt-2">
                        <div class="col-md-6 mb-3 ">
                          <form #form="ngForm" class="addpaynow">
                            <div class="">
                              <div class="card-1 form-group formgroup-tm" *ngIf="customerdetails">
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Customer Email
                                        <span class="text-danger">*</span></label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Email" id="Email" name="Email"  [formControl]="Email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$" required
                                        [(ngModel)]="cemail" (change)="onChangeid()"  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"/>
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{customerEmailAddress()}}</span>
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Customer Id </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Customer ID " id="CustomerID" name="CustomerID"
                                        [formControl]="CustomerID" [(ngModel)]="cid" (change)=onChange() />
                                    </div>
                                    <div style="color:red;" *ngIf="isemployee">Customer Id is already exist</div>
                                    <span class="text-danger"
                                      *ngIf="CustomerID.invalid && (CustomerID.dirty || CustomerID.touched)"></span>
      
                                  </div>
      
                                </div>
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Customer name </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Customer Name " id="CustomerName" name="CustomerName"
                                        [formControl]="CustomerName" [(ngModel)]="cname" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="CustomerName.invalid && (CustomerName.dirty || CustomerName.touched)"></span>
                                  </div>
                                </div>
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Mobile No  </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Mobile No " id="MobileNo" name="MobileNo" maxlength="10"
                                        [formControl]="MobileNo" [(ngModel)]="cmobileno" (change)="onChangeid()" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="MobileNo.invalid && (MobileNo.dirty || MobileNo.touched)">{{mobileNoError()}}</span>
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Date Of Birth  </label>
                                      <input class="formcontrol-user1 form-control" type="date" placeholder="Date Of Birth" id="BirthDay" name="BirthDay"
                                        [(ngModel)]="cBirthDay" [formControl]="BirthDay"  />
                                      <!-- <input class="formcontrol-user1 form-control" type="date" placeholder="Birth Day " id="BirthDay" name="BirthDay"
                                            [formControl]="BirthDay"  max="{{datePickerMaxDate}}"> -->
      
                                    </div>
      
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Notes </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Notes " id="Notes" name="Notes" [formControl]="Notes"
                                        [(ngModel)]="cNotes" />
                                    </div>
                                    <span class="text-danger"  *ngIf="Notes.invalid && (Notes.dirty || Notes.touched)"></span>
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="Contact Preference " id="ContactPerference" name="ContactPerference"  [formControl]="ContactPerference" [(ngModel)]="cContactPerference"/> -->
                                      <label class="customlabel">Contact Preference </label>
                                      <div class="selectcustom mb-0">
                                        <ngx-select [items]="contactrefrence" placeholder="Contact Preference"
                                        id="ContactPerference" name="ContactPerference" [formControl]="ContactPerference"
                                        [(ngModel)]="cContactPerference">
                                      </ngx-select>
                                      </div>
                                      
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="ContactPerference.invalid && (ContactPerference.dirty || ContactPerference.touched)"></span>
                                  </div>
                                </div>
                                <div class=" pt-3" *ngIf="newcustomercreate">
                                  <button type="button" class="btn dash-btns" id="SaveEmployee"
                                  mat-raised-button color="primary" 
                                    (click)="createcustomer()"   [disabled]="MobileNo.invalid||Email.invalid">Save</button>
                                  <!-- [disabled]="employeeId.invalid||firstName.invalid||lastName.invalid||email.invalid ||phoneNo.invalid ||passCode.invalid" -->
                                </div>
      
                                
      
      
      
      
      
      
      
      
      
      
                              </div>
                              <div class="card-1 form-group formgroup-tm" *ngIf="shippingaddress">
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Address1
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Address1 " id="Address1" name="Address1"
                                        [formControl]="Address1" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="Address1.invalid && (Address1.dirty || Address1.touched)"></span>
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Address2
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Address2 " id="Address2" name="Address2"
                                        [formControl]="Address2" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="Address2.invalid && (Address2.dirty || Address2.touched)"></span>
                                  </div>
                                </div>

                                <div class="row pt-2">
                                  
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">ZipCode
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="ZipCode" id="ZipCode" name="ZipCode"
                                        [formControl]="ZipCode" (change)="Getzipcodedetails()"/>
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{shippingZipCodeError()}}</span>
                                  </div>
                                </div>
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">City
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="City" id="City" name="City" [formControl]="City"
                                        keypress="blockSpecialChar($event)" [(ngModel)]="city"/>
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="City.invalid && (City.dirty || City.touched)"></span>
                                  </div>
                                </div>
                                <div class="row pt-2"> 
                                  
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                    <!--  <input class="formcontrol-user1 form-control" type="text" placeholder="State " id="State" name="State" [formControl]="State" />-->
                                    <label class="customlabel">State </label>
                                    <div class="selectcustom mb-0">
                                      <ngx-select [items]="slist" placeholder="State" id="State" name="State" [formControl]="State" [(ngModel)]="state">
                                      </ngx-select>
                                    </div>
                                      
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="State.invalid && (State.dirty || State.touched)"></span>
                                  </div>
                                </div>
                                <!-- <div class="row pt-2">
                                  
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">ZipCode
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="ZipCode" id="ZipCode" name="ZipCode"
                                        [formControl]="ZipCode" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)"></span>
                                  </div>
                                </div> -->
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Country
                                      </label>
                                  <!--   <input class="formcontrol-user1 form-control" type="text" placeholder="Country " id="Country" name="Country"
                                        [formControl]="Country" />-->
                                        <div class="selectcustom mb-0">
                                          <ngx-select [items]="CountryList" placeholder="Country" id="Country" name="Country"
                                          [formControl]="Country" [(ngModel)]="country">
                                        </ngx-select>
                                        </div>
                                       
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="Country.invalid && (Country.dirty || Country.touched)"></span>
                                  </div>
                                </div>
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Shipping Email </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Email " id="ShippingEmail" name="ShippingEmail"
                                        [formControl]="ShippingEmail" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$"/>
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="ShippingEmail.invalid && (ShippingEmail.dirty || ShippingEmail.touched)">{{shippingEmailError()}}</span>
                                  </div>
                                </div>
      
                                <div class="row pt-2"> 
                                  <div class="col-md-12">
                                    <div class="form-group formgroup-tm">
                                      <label class="customlabel">Mobile Number
                                      </label>
                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Mobile Number"maxlength="10"  id="MobileNumber" name="MobileNumber"
                                        [formControl]="MobileNumber" />
                                    </div>
                                    <span class="text-danger"
                                      *ngIf="MobileNumber.invalid && (MobileNumber.dirty || MobileNumber.touched)">{{shippingMobileNumberError()}}</span>
                                  </div>
                                </div>
                              </div>
      
                              <!-- category details -->
      
                              <div class="row">
                                <div class="col-md-12">
                                  <ul class="nav nav-tabs">
                                    <li class="mb-3" type="submit" class="btn category-btn cat-h" (click)=dipalyitems(rows.id)
                                      style="cursor: pointer;" *ngFor="let rows of categories">
                                      <span style="vertical-align: inherit;">{{rows.categoryName}}</span></li>
                                  </ul>
                                </div>
                              </div>      
                              <!-- items details -->
                              <div  class="row" *ngIf="itemslist">
                                <div class="col-md-12"> 
                                  <ul class="nav-1">
                                    <li *ngFor="let row of categoryItems">
                                      <button type="button" class="btn-13 btn custom-btn btn-block btn-height"  (click)=addcart(row.Id,row.Name,row.Price,row.Description,row.CategoryId)>
                                        <span class="d-block"> {{row.Name}}</span>
                                        <span > {{currency}}{{row.Price | number : '1.2-2'}}</span>
                                      </button>
                                    </li>
                                  </ul>   
                                </div>
                              </div>
                              <!-- </div> -->
      
      
      
      
      
      
                            </div>
                          </form>
                        </div> 
                        <div class="col-md-6 pr-md-0">
                          <div>
                           
                            <table class="table  table-bordered mytable" style="width:100%">
                              <thead>
                                <tr bgcolor="#e1e1e1">
                                  <th width="30%">Item Name </th>
                                  <th width="30%">Quantity</th>
                                  <th width="15%">Price</th>
                                  <th width="15%">TaxAmount</th>
                                  <th width="15%">Amount</th>
                                  <th width="5%">Remove</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr bgcolor="#fafbfc" *ngFor="let field of myItems; let i = index">
                                  <td>
                                    <label class="item-label">{{field.ItemName}}</label>
                                    <!-- <input matInput placeholder="Item Name " id="ItemName"  class="form-control" name="{{field.ItemCategory}}"  [(ngModel)]="field.ItemCategory"> 
                                                              -->
                                  </td>
                                  <td>
                                    <div  >
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-primary" style="padding: 3px 6px; border-radius: 0!important; border: none;" (click)="decrementchoc(field.Quantity,field.Amount,field.ItemPrice,field.ItemName,field.TaxAmount)" data-type="minus" data-field="quant[2]">
                                        <span class="qtyminus"><i class="fa fa-minus text-white" aria-hidden="true"></i></span>
                                      </button>
                                    </span>
      
                                    <label class="mb-0 text-center b"  style="width: 27px; font-size: 11px; padding: 4px;">{{field.Quantity}}</label>
      
                                    <!-- <input matInput placeholder="Quantity" id="Quantity" class="form-control" name="{{field.Quantity}}" [(ngModel)]="field.Quantity" value="1" style="width: 50px"> 
                                                            -->
      
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-primary" style="padding: 3px 6px; border-radius: 0!important; border: none;"  (click)="incrementchoc(field.Quantity,field.Amount,field.ItemPrice,field.ItemName,field.TaxAmount)" click=billcalaculation1(field.ItemCategory) data-type="plus" data-field="quant[2]">
                                        <span class="qtyplus"><i class="fa fa-plus text-white" aria-hidden="true"></i>
                                        </span>
                                      </button>
                                    </span>
                                    </div>
                                  </td>
                                  <td>
                                    <label class="robot item-label">{{currency}}{{field.ItemPrice| number : '1.2-2'}}</label>
      
      
                                  </td>
                                  <td>
                                    <label class="item-label">{{currency}}{{field.TaxAmount| number : '1.2-2'}}</label>
      
      
                                  </td>
                                  <!-- <td>
                                    <label class="item-label">₹{{field.DisCountAmount| number : '1.2-2'}}</label>
      
      
                                  </td> -->
                                  
                                  <td>
                                    <!-- <input matInput placeholder="Amount" id="Amount" class="form-control" name="{{field.Amount}}" [(ngModel)]="field.Amount"> -->
                                    <label class="robot item-label">{{currency}}{{field.Amount| number : '1.2-2'}}</label>
                                  </td>
      
                                  <td align="center">
                                    <a class="text-center text-danger"  (click)="deleteitem(i,field.Id,field.Quantity,field.Amount,field.ItemPrice,field.ItemCategory)">
                                      <i class="far fa-trash-alt mr-2" aria-hidden="true"
                                     ></i>
                                    </a>
                                   
                                  </td>
      
      
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- <a  (click)="Applycouponcode()" class="text-danger d-block text-right" *ngIf="couponcode">Apply Coupon</a>
                          -->
                         
                         
                          <div class="pt-2" *ngIf="Applycouponscode" >
                            <table width="100%">
                              <tr align="right">
      
                                <td>
                                  <div class="form-group formgroup-tm">
                                    <input type="text" class="formcontrol-user1 form-control" placeholder="Coupon code" id="Ccode"
                                      [formControl]="Ccode" (ngModelChange)="Applycoupon()" />
                                      <span *ngIf="invalidcouponmsg" class="text-danger"> Invalid Coupon</span>
                                  </div>
                            
                                  
                                </td>
                                <td>
                                  <button type="button" class="btn dash-btns" id="Savecoupon"
                                    mat-raised-button color="primary"  (click)="checkcouponcode()" [disabled]="btncoupon"
                                    >Apply coupon</button>
                                    
      
                                </td>
      
                              </tr>
                              
      
                            </table>
      
      
                          </div>
                          <a *ngIf="removecoupons" (click)="Removecouponcode()" class="text-danger d-block text-right">Remove coupon</a>

                         
                          <div class="pt-2">
                            <table width="100%" *ngIf="isbillcalculate">
                              <tr align="right">
                                <td>
                                  <button type="button" class="dash-btns btn-block mr-3"  id="SaveEmployee"
                                    mat-raised-button color="primary" (click)="NewOrderCreation()">Save</button>
      
                                </td>
                                <td>
                                  <button type="button" class="dash-btns btn-block mr-3"  id="SaveEmployee"
                                    mat-raised-button color="primary" (click)="NewOrderCreationWithCash()">Cash</button>
      
                                </td>
                                <td>
                                  <button type="button" class="dash-btns btn-block"  id="SaveEmployee"
                                    mat-raised-button color="primary"
                                    (click)="NewOrderCreationWithEmail()">Email/Text</button>
      
                                </td>
                                <!-- <td>
                                  <button type="button" class="dash-btns mr-3"  id="SaveEmployee"
                                    mat-raised-button color="primary" (click)="NewOrderCreation()">COD</button>
      
                                </td> -->
                              </tr>
                            </table>
      
                            <!-- <a  (click)="Applycouponcode()" class="text-danger d-block text-right" *ngIf="couponcode">Apply Coupon</a> -->
                          </div>
                          <div class="pt-2" *ngIf="cashpay">
                            <table width="100%">
                              <tr align="right">
      
                                <td>
                                  <div class="form-group formgroup-tm">
                                    <input class="formcontrol-user1 form-control" type="text" placeholder="Tender Amount " id="tenderamount" name="tenderamount"
                                      [formControl]="tenderamount" (ngModelChange)="amountcal()" />
                                  </div>
                                </td>
                                <td>
                                  <h6>Return Amount <label>{{rtnamount | number : '1.2-2'}}</label></h6>
      
                                </td>
                                <td>
                                  <button type="button" class="btn dash-btns" id="SaveEmployee"
                                    mat-raised-button color="primary" (click)="NewOrderCreation()"
                                    [disabled]="tenderamount.invalid || invalidamount"> Place Order</button>
      
                                </td>
      
                              </tr>
                              <span class="text-danger"
                                *ngIf="tenderamount.invalid && (tenderamount.dirty || tenderamount.touched)">{{tenderamounterror()}}</span>
                              <label class="text-danger" *ngIf="invalidamount">Invalid Amount</label>
                            </table>
      
      
                          </div>
                          <div class="pt-2" *ngIf="SendEmail">
                            <table width="100%">
                              <tr align="right">
      
                                <td>
                                  <div class="form-group formgroup-tm">
                                    <input type="text" class="formcontrol-user1 form-control" placeholder="Email or Mobile Number" id="mail" name="mail"
                                      [formControl]="mail" [(ngModel)]="Customermail" change="sendEmail()" />
                                  </div>
                                </td>
                                <td>
                                  <button type="button" class="btn dash-btns" id="SaveEmployee"
                                    mat-raised-button color="primary" (click)="NewOrderCreation()"
                                    [disabled]="mail.invalid">Place Order</button>
      
                                </td>
      
                              </tr>
                              <span class="text-danger"
                                *ngIf="mail.invalid && (mail.dirty || mail.touched)">{{Emailmobilenumber()}}</span>
      
                            </table>
      
      
                          </div>
      
                       
                        </div>
                      </div>
                    </div>
                  </form>              
              </div>
          </div>
      </div>
  </section>

</div>





 